import { LOCALE_STORAGE_KEYS } from 'common/constants/localeStorageConstants'
import { UtilService } from 'common/services/utilService'

type ScheduleDoctorRailOrderStore = Record<string, number[]>

const isStoredUserId = (userId: number | null | undefined): userId is number =>
  userId != null && !Number.isNaN(Number(userId))

const readStore = (): ScheduleDoctorRailOrderStore => {
  try {
    const raw = window.localStorage.getItem(LOCALE_STORAGE_KEYS.SCHEDULE_DOCTOR_RAIL_ORDER)
    if (!raw) return {}
    const parsed = UtilService.safeParseJSON<ScheduleDoctorRailOrderStore | null>(raw, null)
    if (!parsed || typeof parsed !== 'object') return {}
    return parsed
  } catch {
    return {}
  }
}

const writeStore = (store: ScheduleDoctorRailOrderStore): void => {
  try {
    window.localStorage.setItem(
      LOCALE_STORAGE_KEYS.SCHEDULE_DOCTOR_RAIL_ORDER,
      JSON.stringify(store),
    )
  } catch {
    // Storage can fail (private mode, quota); ignore.
  }
}

const cleanIds = (value: unknown): number[] => {
  if (!Array.isArray(value)) return []
  const ids: number[] = []
  const seen = new Set<number>()
  for (const entry of value) {
    const id = Number(entry)
    if (!Number.isInteger(id) || id < 0 || seen.has(id)) continue
    seen.add(id)
    ids.push(id)
  }
  return ids
}

export const getScheduleDoctorRailOrder = (userId: number | null | undefined): number[] => {
  if (!isStoredUserId(userId)) return []
  return cleanIds(readStore()[String(userId)])
}

export const setScheduleDoctorRailOrder = (
  userId: number | null | undefined,
  orderedIds: number[],
): number[] => {
  const next = cleanIds(orderedIds)
  if (!isStoredUserId(userId)) return next

  const store = readStore()
  store[String(userId)] = next
  writeStore(store)
  return next
}
